import BraSizeChart from './BraSizeChart'

export default BraSizeChart
